import {
    Card,
    CardBorderRadius,
    CardBorderStyle,
    CardHeaderTheme,
    CardTheme,
    AddressLocation,
    AddressLocationIndicatorStyle,
    AddressLocationLine1Style,
    AddressLocationFontSize,
    AddressLocationControlPadding,
} from '@apply/components';
import { PropertiesTable } from './components/PropertiesTable/PropertiesTable';
import { GCUserProperty } from '@apply/api/src/api/ApplyApi';
import { addressBuilder } from './constants/addressBuilder';

export interface PortfolioPanelProps {
    properties: GCUserProperty[];
    onRefresh: () => void;
}

export const PortfolioPanel: React.FC<PortfolioPanelProps> = ({ properties, onRefresh }) => {
    const headerContentAddress = () => {
        return (
            <AddressLocation
                addressLine1={addressBuilder(properties[0])}
                indicatorStyle={AddressLocationIndicatorStyle.Gray}
                line1Style={AddressLocationLine1Style.Bold}
                controlPadding={AddressLocationControlPadding.None}
                fontSize={AddressLocationFontSize.Smaller}
                showIndicator={false}
            />
        );
    };

    return (
        <>
            <Card
                header={headerContentAddress()}
                headerTheme={CardHeaderTheme.Gray}
                theme={CardTheme.White}
                borderRadius={CardBorderRadius.Small}
                borderStyle={CardBorderStyle.Solid}
            >
                <PropertiesTable
                    isPortfolio={true}
                    properties={properties}
                    onRefresh={onRefresh}
                />
            </Card>
        </>
    );
};
